import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ServerErrorService } from '../services/server-error.service';
import { Utils } from '../services/utils';

@Injectable()
export class FarmRiseErrorHandler implements ErrorHandler {

  serverErrorService: ServerErrorService;
  utils: Utils;

  constructor(private injector: Injector) {
    this.serverErrorService = this.injector.get(ServerErrorService);
    this.utils = this.injector.get(Utils);
  }

  handleError(error: any) {
    this.utils.hideSpinner();
    if (error instanceof HttpErrorResponse) {
      console.log('Http Status : ' + error.status);
      this.serverErrorService.processError(error);
    } else {
      console.log('Error : ' + error);
    }
  }
}